<template>
  <v-dialog width="480" v-model="active" persistent>
    <v-card color="primary" class="rounded-sm" v-if="item">
      <v-card-title>
        <div class="text-h6">Editar accesorio</div>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="closeDialog()" icon><v-icon>mdi-window-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-model="itemForm" ref="form">
          <v-select
            label="Tipo de accesorio"
            v-model="item.fk_idCatTipoItem"
            :items="tipoItem"
            item-color="secondary"
            item-value="id"
            item-text="title"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
            :rules="required"
          >
            <template v-slot:label>Tipo de accesorio <span class="red--text">*</span> </template>
          </v-select>
          <v-text-field
            label="Nombre del accesorio"
            v-model="item.item"
            rounded
            filled
            dense
            color="secondary"
            background-color="primary"
            :rules="required"
          >
            <template v-slot:label>Nombre del accesorio <span class="red--text">*</span> </template>
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn @click="triggerSaveItem()" color="secondary" :loading="loading" :disabled="loading || !itemForm"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    active: {
      type: Boolean,
    },

    item: {
      type: Object,
    },
  },

  data() {
    return {
      loading: false,
      itemForm: false,

      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('tipoItemArmeria', {
      tipoItem: 'getTipoItem',
    }),
  },

  methods: {
    ...mapActions('itemArmeria', ['updateItem', 'fetchItems']),

    closeDialog() {
      this.$refs.form.resetValidation()
      this.loading = false
      this.$emit('close')
    },

    async triggerSaveItem() {
      this.loading = true
      await this.updateItem(this.item)
      await this.fetchItems(this.item.fk_idCatTipoItem)

      this.closeDialog()
    },
  },
}
</script>
